import API from '@/api/base'
import { validationError } from '@/utils/form-helpers'

export const state = {
  items: [],
  locationOrders: [],
  locationOrdersComplete: false,
  order: null,
  orders: [], // past customer orders
}

export const getters = {
  getOrder: ({ order }) => order,
  getItems: ({ items }) => items,
  getLocationOrders: ({ locationOrders }) => locationOrders,
  getLocationOrdersComplete: ({ locationOrdersComplete }) =>
    locationOrdersComplete,
  getOrders: ({ orders }) => orders,
  getStandardItems: ({ items }) => items.filter((i) => !i.subscription),
  getSubscriptionItems: ({ items }) => items.filter((i) => i.subscription),
}

export const actions = {
  fetchOrders: ({ commit, rootGetters }) =>
    new Promise((resolve, reject) => {
      const user = rootGetters['auth/getUser']
      API.findAll('order', {
        query: { customer_id: user.id },
        include: ['order_item'],
      })
        .then((response) => {
          commit('SET_ORDERS', response.data)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    }),

  fetchLocationOrders: ({ commit }, { locationId, query }) =>
    new Promise((resolve, reject) => {
      API.findAll('order', {
        query: {
          location_id: locationId,
        },
        filter: {
          ...query,
        },
      })
        .then((response) => {
          commit('SET_LOCATION_ORDERS', response.data)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    }),

  submitOrder: ({ commit, dispatch, rootGetters }, params) =>
    new Promise((resolve, reject) => {
      // Gather information needed for order submission
      const siteId = rootGetters['sites/getSiteId']
      const customerId = rootGetters['customers/getCustomer'].id
      const cartId = rootGetters['shoppingCart/getShoppingCartId']
      const delivery = rootGetters['customers/getDelivery']
      const cardInfo = rootGetters['customers/getPayment']
      const fulfillment = rootGetters['locations/getFulfillment']
      const shipping = rootGetters['customers/getShipping']

      // Submit order to API
      API.create('order', {
        additionalNotes: params.additionalNotes,
        applyDeliveryFee: params.applyDeliveryFee,
        deliveryBuilding: delivery.building,
        deliveryRoom: delivery.roomNo,
        deliveryNotes: delivery.additionalNotes,
        shoppingCart: {
          id: cartId,
        },
        customer: {
          id: customerId,
        },
        site: {
          id: siteId,
        },
        location: {
          id: fulfillment.location.id,
        },
        fulfillment: params.fulfillmentMethod,
        fulfillmentDate: fulfillment.pickupDate,
        fulfillmentTime: fulfillment.pickupTime,
        meta: {
          paymentType: params.paymentMethod,
          cardFirstName: cardInfo.ccFirstName,
          cardLastName: cardInfo.ccLastName,
          cardNumber: cardInfo.ccCardNumber,
          cardType: cardInfo.ccCardType,
          cardExpirationMonth: cardInfo.ccCardExpirationMonth,
          cardExpirationYear: cardInfo.ccCardExpirationYear,
          cardCvv: cardInfo.ccSecurityCode,
        },
        shipping: {
          firstName: shipping.firstName,
          lastName: shipping.lastName,
          address: shipping.address,
          address2: shipping.address2,
          city: shipping.city,
          state: shipping.state,
          zipCode: shipping.zipCode,
          phone: shipping.phoneNumber,
        },
      })
        .then((response) => {
          commit('SET_ITEMS', response.data.items)
          commit('SET_ORDER', response.data)
          // Generate new cart
          dispatch(
            'shoppingCart/generateNewCart',
            {},
            {
              root: true,
            }
          )
          resolve()
        })
        .catch((err) => {
          const msg =
            'An error occurred while attempting to process your order.' +
            ' Please check your information and try again.'
          const error = validationError('order', msg, err)
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            err.response.data.errors[0] &&
            err.response.data.errors[0].detail
          ) {
            error.detail = err.response.data.errors[0].detail
          }
          reject(error)
        })
    }),

  // Clears the stored order in vuex
  clearOrder: ({ commit }) => commit('SET_ORDER', null),
  clearItems: ({ commit }) => commit('SET_ITEMS', []),
}

export const mutations = {
  SET_LOCATION_ORDERS(state, locationOrders) {
    state.locationOrders = locationOrders
    state.locationOrdersComplete = true
  },
  SET_ORDER(state, order) {
    state.order = order
  },
  SET_ITEMS(state, items) {
    state.items = items
  },
  SET_ORDERS(state, orders) {
    state.orders = orders
  },
}
